import { Box } from "@mui/material";
import React from "react";
import Menu from "./Menu";
import MenuV2 from "./MenuV2";

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  children?: React.ReactNode | React.ReactNode[];
  variant?: "v1" | "v2";
  /**
   * Flow mode: hides the Profile link and intercepts logo clicks with a
   * confirmation dialog. Only honored by the v2 variant.
   */
  disableNavigation?: boolean;
}

const Template = ({ children, variant = "v1", disableNavigation }: Props) => (
  <Box
    sx={{
      minHeight: "100vh",
      maxWidth: "100vw",
      overflowX: "hidden",
      background:
        "linear-gradient(339deg, #F7F1EA 36.57%, #FDFCFA 72.98%, #FBFBFB 86.11%)",
    }}
    flexDirection="column"
    display="flex"
  >
    {variant === "v2" ? (
      <MenuV2 disableNavigation={disableNavigation} />
    ) : (
      <Menu />
    )}
    {children}
  </Box>
);

export default Template;
